import { useContext } from 'react';
import { FolderMenuItemsContext } from '../Context';

export const useFolderMenuItems = () => {
  const ctx = useContext(FolderMenuItemsContext);

  return ctx;
};

export default useFolderMenuItems;